import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import WatermarkPDFImageListScreen from "./WatermarkPDFImageListScreen";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import { BASE_URL } from "../Config";
import MiscFAQ from "../misc_components/MiscFAQ";
import MiscRecommendedPages from "../misc_components/MiscRecommendedPages";

function WatermarkPDFMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || { title: "Watermark PDF files" };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/watermark_pdf", title: "Add watermark to PDF documents" },
    data2: { link: "/watermark_pdf", title: "Copyright PDF files" },
    data3: { link: "/watermark_pdf", title: "PDF watermark tool" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Add watermark to PDF online easily. Insert text or image watermarks to protect documents quickly with our fast and secure PDF watermark tool."
      ></meta>
      <meta
        name="keywords"
        content="watermark pdf, add watermark to pdf, pdf watermark tool, pdf watermark online, insert watermark pdf, text watermark pdf, image watermark pdf, protect pdf documents, pdf editor online, online pdf watermark, add logo to pdf, pdf branding tool, watermark pdf free, secure pdf watermark, pdf document protection, add copyright to pdf, add watermarks to selected pages of pdf file, add watermark logo to pdf, add background image to pdf, add custom text watermark to pdf, add copyright protection to pdf,"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <WatermarkPDFImageListScreen
          title={title}
        ></WatermarkPDFImageListScreen>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={true}
            filetype={{ "application/pdf": [".pdf"] }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Watermark PDF Offline App is a powerful and easy-to-use solution designed to help users add watermark to PDF files with ease, whether you prefer working offline or need features similar to add watermark PDF online tools. This offline PDF watermark app ensures complete privacy and security, as all processing is done directly on your device with no file uploads or data sharing. Whether you want to protect documents, add a logo, brand your files, or mark PDFs as confidential, this PDF watermarking tool delivers fast and reliable performance. Users can customize watermark text or image, font style, size, color, opacity, rotation, and position to create professional-quality watermarked PDFs in just a few taps. Ideal for students, professionals, freelancers, and businesses, this PDF editor maintains original document quality while allowing you to add a watermark to PDF files quickly and securely. With no app-added watermarks, no sign-up required, and full offline functionality, this watermark PDF app is a smart alternative to add watermark PDF online services, giving you complete control anytime, anywhere." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Watermark",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="Watermark PDF"
            why_use={[
              {
                title: "Protect Document Ownership",
                description:
                  "Adding a watermark to PDF files helps protect your content from unauthorized use. A PDF watermark clearly shows ownership, making it ideal for copyrighted documents, reports, and digital assets.",
              },
              {
                title: "Enhance Document Security",
                description:
                  "Watermark PDF tools add an extra layer of security by marking files as confidential, draft, or private. This discourages misuse and ensures sensitive information remains protected.",
              },
              {
                title: "Professional Branding",
                description:
                  "Using a PDF watermark allows businesses and professionals to add logos, brand names, or custom text. This improves brand visibility and creates a professional appearance in shared documents.",
              },

              {
                title: "Prevent Unauthorized Sharing",
                description:
                  "When you add a watermark to PDF files, it becomes harder for others to distribute or claim your content as their own, especially for invoices, eBooks, and official documents.",
              },
              {
                title: "Maintain Original File Quality",
                description:
                  "Modern watermark PDF apps let you add watermarks without affecting the original PDF quality, ensuring clarity while keeping file size optimized.",
              },
              {
                title: "Offline and Online Flexibility",
                description:
                  "With watermark PDF offline apps, you can add watermarks without an internet connection, offering more privacy compared to add watermark PDF online tools.",
              },
              {
                title: "Customizable Watermark Options",
                description:
                  "You can customize watermark text, image, font size, color, opacity, rotation, and placement, giving full control over how the watermark appears on your PDF.",
              },
              {
                title: "Ideal for Students and Professionals",
                description:
                  "Students, teachers, freelancers, and businesses use PDF watermarking to label assignments, research papers, contracts, and proposals effectively.",
              },
              {
                title: "Fast and Easy PDF Editing",
                description:
                  "Watermark PDF tools are designed for quick processing, allowing users to add a watermark to PDF files in just a few clicks, saving time and effort.",
              },
            ]}
          />
          {/* FAQ */}
          <MiscFAQ
            faq_list={[
              {
                title: "How can I add a watermark to a PDF for free?",
                description:
                  "Use ShivaPDF's Watermark PDF tool to add a text or image watermark to your PDF document. Customize the watermark using the available settings and download the watermarked PDF.",
              },
              {
                title: "Can I watermark a PDF offline?",
                description:
                  "If the Watermark PDF tool supports offline processing, you can add watermarks without sending your document to a remote server. Offline use may require loading the tool before disconnecting from the internet.",
              },
              {
                title: "Does ShivaPDF process PDF watermarks locally?",
                description:
                  "Local processing means your PDF is modified directly on your device rather than on a remote server. Check the tool's implementation to confirm that watermarking and file handling happen locally.",
              },
              {
                title: "Is the Watermark PDF tool free to use?",
                description:
                  "ShivaPDF provides online PDF tools designed to make document editing simple. Visit the Watermark PDF page to check the current availability, usage limits, and any restrictions.",
              },
              {
                title: "Can I add a text watermark to a PDF?",
                description:
                  "Yes, a text watermark can display information such as Draft, Confidential, Sample, Copyright, or your company name across a PDF document.",
              },
              {
                title: "Can I add a logo or image watermark to a PDF?",
                description:
                  "If image-watermark support is available, you can place a logo, signature image, or other graphic on your PDF pages to identify your brand or document ownership.",
              },
              {
                title: "Can I customize the position of a PDF watermark?",
                description:
                  "Watermark positioning options can help you place text or images in the center, a corner, or another supported location on each PDF page.",
              },
              {
                title: "Can I change the watermark opacity and size?",
                description:
                  "If supported by the tool, you can adjust the watermark's opacity and size to keep it visible without making the document difficult to read.",
              },
              {
                title: "Can I rotate a watermark diagonally across PDF pages?",
                description:
                  "A diagonal watermark is commonly used for labels such as Draft, Confidential, or Sample. Check the available rotation settings to see whether you can angle the watermark across your pages.",
              },
              {
                title: "Can I change the font and color of a text watermark?",
                description:
                  "Depending on the available settings, you can customize the font, text size, and color of a watermark to suit your document's design and purpose.",
              },
              {
                title: "Can I add a watermark to every page of a PDF?",
                description:
                  "If the tool provides an all-pages option, you can apply the same watermark throughout the document instead of editing each page individually.",
              },
              {
                title: "Can I watermark only selected PDF pages?",
                description:
                  "Some PDF watermark tools allow you to choose specific pages or page ranges. Check the available page-selection options before processing your document.",
              },
              {
                title: "Can I add a Draft or Confidential watermark to a PDF?",
                description:
                  "Yes, text watermarks such as Draft, Confidential, Approved, and Internal Use Only can help communicate a document's status when it is shared or printed.",
              },
              {
                title: "Can I watermark a password-protected PDF?",
                description:
                  "A password-protected PDF may need to be unlocked before it can be modified. Whether watermarking is possible depends on the document's permissions and the tool's supported workflow.",
              },
              {
                title: "Will adding a watermark change my PDF content?",
                description:
                  "Watermarking adds visible text or an image over or behind the page content. Review the output to make sure the watermark does not obscure important text, images, or form fields.",
              },
              {
                title: "Will watermarking increase the PDF file size?",
                description:
                  "The file size may increase when a watermark image, font, or additional PDF content is embedded. The amount depends on the watermark and the document's existing structure.",
              },
              {
                title: "Can I add a watermark without uploading my PDF?",
                description:
                  "If ShivaPDF's tool processes the document entirely in your browser, you may be able to watermark it without uploading it to a server. Confirm that local processing is supported before relying on this feature.",
              },
              {
                title: "Are my PDF files private when using ShivaPDF?",
                description:
                  "Privacy depends on how the tool processes and handles documents. For sensitive files, verify that local processing is enabled and review ShivaPDF's privacy policy.",
              },
              {
                title: "Do I need to install software to watermark a PDF?",
                description:
                  "A browser-based PDF watermark tool can let you edit documents without installing a separate application. Internet access may still be required to open the website unless offline access is supported.",
              },
              {
                title: "Can I watermark a PDF on my mobile phone?",
                description:
                  "If the tool is compatible with your mobile browser, you can add watermarks to PDF documents using a supported smartphone or tablet.",
              },
              {
                title: "Can I use a watermark to protect PDF documents?",
                description:
                  "A watermark can identify a document's owner or indicate its intended use. However, a visible watermark does not prevent copying, editing, screenshots, or unauthorized distribution on its own.",
              },
              {
                title: "Can I add a copyright watermark to a PDF?",
                description:
                  "You can use a copyright notice, author name, company name, or website address as a watermark to help identify ownership of a PDF document.",
              },
              {
                title: "How do I download a watermarked PDF?",
                description:
                  "After applying the watermark and reviewing the result, use the tool's download or export option to save the modified PDF to your device.",
              },
              {
                title: "Does a watermark affect PDF text search?",
                description:
                  "A watermark usually adds visual content to PDF pages, but the effect on text search and selection depends on how the watermark is created and how the PDF is processed. Check the output if searchable text is important.",
              },
            ]} />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app/id${1615002918}`}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Recommended Tools */}
          <MiscRecommendedPages />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default WatermarkPDFMain;
